import { ref } from 'vue'

const houseId = ref( '142658' )

const selectedArea = ref( null )

const houseFloorsCount = ref( undefined )

export { houseId, selectedArea, houseFloorsCount }